import type { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "../table/header";
import { DataTableRowActions } from "./financial-disclosures.actions";

type FinancialDisclosure = {
  id: string;
  personName: string;
  year: number;
  disclosureType: string;
  office: string;
  filingDate: Date;
  documentMedia?: {
    id: string;
    title: string;
    cloudStorageObject: {
      fullUrl: string;
    };
  } | null;
};

export const columns: ColumnDef<FinancialDisclosure>[] = [
  {
    accessorKey: "personName",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Person Name" />
    ),
  },
  {
    accessorKey: "year",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Year" />
    ),
  },
  {
    accessorKey: "disclosureType",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Type" />
    ),
    cell: ({ row }) => {
      const type = row.getValue("disclosureType") as string;
      return (
        <span className="capitalize">
          {type === "conflict-of-interest"
            ? "Conflict of Interest"
            : "Campaign"}
        </span>
      );
    },
  },
  {
    accessorKey: "office",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Office" />
    ),
  },
  {
    accessorKey: "filingDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Filing Date" />
    ),
    cell: ({ row }) => {
      const date = new Date(row.getValue("filingDate"));
      return <span>{date.toLocaleDateString()}</span>;
    },
  },
  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
